import axios from 'axios';
import rutas from '@/assets/utils/rutas.json';

export const fetchTipoImagenSelect = async () => {
  const query = `
    query obtenerTipoImagen {
      allTipoimagen {
        descripcion
        id
      }
    }
  `;
  try {
    const response = await axios.post(`${rutas.axios}api`, { query });

    return response.data.data.allTipoimagen.map(item => ({
      value    : item.id,
      text     : item.descripcion,
    }));

  } catch (error) {
    console.error('An error occurred while fetching the options:', error);
    return [];
  }
}


export const getLateralidadesImagen = async () => {
  const query = `
    query {
      allLateridades {
        id
        descripcion
        nombre
      }
    }
  `;

  try {
    const response = await axios.post(rutas.axios + 'api', { query });

    if (response.status !== 200) return null;

    const response2 = response.data.data.allLateridades;

    const data = response2.map(item => ({
      value: item.id,
      text: item.nombre,
    }));

    return data;

  }catch(error){
    console.error("error al obtener las lateralidades:", error);
    return [];
  }
}
